import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import { isFetchingSqlQuery, receiveSqlQuery } from "../actionCreators";
import { SqlQueryReducerState } from "../types";

const initialState: SqlQueryReducerState = {
  data: null,
  isFetching: false,
};

const sqlQueryReducer = reducer(
  initialState,
  on(receiveSqlQuery, (state, { payload: { sqlQuery } }) => {
    // eslint-disable-next-line no-param-reassign
    state.data = sqlQuery;
  }),
  on(isFetchingSqlQuery, (state, { payload: { isFetching } }) => {
    // eslint-disable-next-line no-param-reassign
    state.isFetching = isFetching;
  })
);

export default sqlQueryReducer;
